<template>
  <MDBModal class="ReportDownloadModal" tabindex="-1" labelledby="ReportDownloadModal" @hide="$emit('onClose')" v-bind="$attrs">
    <MDBModalHeader>
      <MDBModalTitle> Download File </MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody>
      Are you sure you want to download the file <br />
      <span>{{ name }}?</span>
    </MDBModalBody>
    <MDBModalFooter>
      <MDBBtn class="close" color="light" @click="$emit('onClose')">Cancel</MDBBtn>
      <MDBBtn class="download" color="success" @click="$emit('download')">Yes, Download File</MDBBtn>
    </MDBModalFooter>
  </MDBModal>
  <ReportDownloadSnackbar />
</template>
<style lang="scss" scoped>
.ReportDownloadModal {
  .modal-header {
    border-top: 8px solid $green-300;
    border-bottom: none;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: $neutral-800;
    padding-block: 8px;
    padding-inline: 24px;
  }
  .modal-body {
    font-weight: 400;
    padding: 12px 24px;
    font-size: 16px;
    line-height: 24px;

    span {
      font-weight: 500;
    }
  }
  .modal-footer {
    padding-block: 12px;
    padding-inline: 20px;
    .btn {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      padding: 4px 8px;
      box-shadow: none;
      text-transform: capitalize;
    }
    .btn.close {
      color: $neutral-400;
      opacity: 1;
    }
    .btn.download {
      color: $neutral-0;
      background-color: $green-300;
    }
  }
}
</style>
<script>
import { MDBModal, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter, MDBBtn } from 'mdb-vue-ui-kit';
import ReportDownloadSnackbar from './ReportDownloadSnackbar.vue';

export default {
  name: 'ReportDownloadModal',
  components: {
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
    ReportDownloadSnackbar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  emits: ['download', 'onClose'],
  setup(props) {
    return {
      ...props,
    };
  },
};
</script>
